import { z } from 'zod';

export const companyDocumentoFiscalInputSchema = z.object({
  modelo: z
    .number({ invalid_type_error: 'Modelo obrigatório' })
    .int('Use número inteiro')
    .positive('Deve ser maior que zero'),
  serie: z.string().trim().min(1, 'Série obrigatória').max(20, 'Máximo 20 caracteres'),
  descricaoNF: z.enum(['T', 'R'], { errorMap: () => ({ message: 'Selecione T ou R' }) }),
  ambienteNF: z
    .number({ invalid_type_error: 'Ambiente obrigatório' })
    .int('Use número inteiro')
    .min(1, 'Deve ser 1 (Produção) ou 2 (Homologação)')
    .max(2, 'Deve ser 1 (Produção) ou 2 (Homologação)'),
  tipoIntegracaoNF: z
    .enum(['INN', 'WSN', 'WSE', 'WSM', ''], {
      errorMap: () => ({ message: 'Selecione um tipo de integração válido' }),
    })
    .transform((v) => (v === '' ? null : v))
    .nullish(),
  tributacaoServico: z
    .number({ invalid_type_error: 'Valor inválido' })
    .nonnegative('Não pode ser negativo')
    .nullish()
    .transform((v) => (v == null ? null : v)),
  municipioTributacao: z
    .string()
    .trim()
    .max(20, 'Máximo 20 caracteres')
    .nullish()
    .transform((v) => (v == null || v === '' ? null : v)),
  nbsCodigo: z
    .string()
    .trim()
    .max(20, 'Máximo 20 caracteres')
    .nullish()
    .transform((v) => (v == null || v === '' ? null : v)),
  ibsIndicadorOperacao: z
    .string()
    .trim()
    .max(10, 'Máximo 10 caracteres')
    .nullish()
    .transform((v) => (v == null || v === '' ? null : v)),
  ibsSituacaoTributaria: z
    .string()
    .trim()
    .max(10, 'Máximo 10 caracteres')
    .nullish()
    .transform((v) => (v == null || v === '' ? null : v)),
  ibsClassificacaoTributaria: z
    .string()
    .trim()
    .max(10, 'Máximo 10 caracteres')
    .nullish()
    .transform((v) => (v == null || v === '' ? null : v)),
  cstSituacaoTributariaPisCofins: z
    .string()
    .trim()
    .max(2, 'Máximo 2 caracteres')
    .nullish()
    .transform((v) => (v == null || v === '' ? null : v)),
  tipoRetencaoPisCofins: z
    .string()
    .trim()
    .max(1, 'Máximo 1 caractere')
    .nullish()
    .transform((v) => (v == null || v === '' ? null : v)),
});

export type CompanyDocumentoFiscalFormValues = z.input<typeof companyDocumentoFiscalInputSchema>;
